import * as React from "react";

import { LDFlagSet } from "launchdarkly-js-sdk-common";
// eslint-disable-next-line no-restricted-imports
import { useFlags } from "launchdarkly-react-client-sdk";

import { Merchant } from "client/lib/apt-merchant";

type FeatureFlagCtx = [
  LDFlagSet,
  React.Dispatch<React.SetStateAction<LDFlagSet>>
];

export const FlagsContext = React.createContext<FeatureFlagCtx | undefined>(
  undefined
);

export const useFeatureFlags = (): FeatureFlagCtx => {
  const ctx = React.useContext(FlagsContext);
  if (ctx === undefined) {
    throw new Error(
      `useFeatureFlags must be used within a FlagsContext provider`
    );
  }
  return ctx;
};

export const FlagsProvider: React.FC = ({ children }) => {
  // launch darkly polls / auto updates. This components purpose is to cache feature flags for toggling in dev-tools
  const ldFlags = useFlags();
  const [featureFlags, setFeatureFlags] = React.useState(ldFlags);
  const [_, forceUpdate] = React.useReducer((x) => x + 1, 0);

  React.useEffect(() => {
    setFeatureFlags(ldFlags);
  }, [ldFlags]);

  React.useEffect(() => {
    Merchant.flagsInstance = featureFlags;
    // after we update a flag in the merchant model we need to update re-render react, hence below set state
    forceUpdate();
  }, [featureFlags]);

  return (
    <FlagsContext.Provider value={[featureFlags, setFeatureFlags]}>
      {children}
    </FlagsContext.Provider>
  );
};
